import type { StandaloneAssetBrandPresence } from "@runcheetah/shared";

import type { SocialPostGenerationStatus } from "./types";

export const POST_TYPE_OPTIONS = [
  {
    value: "feed_portrait",
    label: "Instagram Feed Portrait",
    description: "1080 x 1350",
  },
  {
    value: "feed_square",
    label: "Instagram Feed Square",
    description: "1080 x 1080",
  },
  {
    value: "carousel_portrait",
    label: "Instagram Carousel Portrait",
    description: "1080 x 1350 slides",
  },
  {
    value: "carousel_square",
    label: "Instagram Carousel Square",
    description: "1080 x 1080 slides",
  },
  {
    value: "story",
    label: "Instagram Story",
    description: "1080 x 1920",
  },
  {
    value: "tiktok_portrait",
    label: "TikTok Portrait",
    description: "1080 x 1920",
  },
  {
    value: "tiktok_carousel_portrait",
    label: "TikTok Carousel Portrait",
    description: "1080 x 1920 slides",
  },
] as const;
export type PlannerPostType = (typeof POST_TYPE_OPTIONS)[number]["value"];

export type PlannerGenerationMode = "auto" | "template" | "freestyle";
export type PlannerBrandPresence = StandaloneAssetBrandPresence;

export const TASK_STATUS_STYLES: Record<SocialPostGenerationStatus, string> = {
  queued: "border-blue-200 bg-blue-50 text-blue-700",
  processing: "border-amber-200 bg-amber-50 text-amber-700",
  done: "border-green-200 bg-green-50 text-green-700",
  failed: "border-red-200 bg-red-50 text-red-700",
};

export const DEFAULT_PROMPT = "Create a social post concept for this brand.";
export const DEFAULT_NON_BRANDED_PROMPT =
  "Create a social post concept for the selected audience without direct brand or product promotion.";

export const buildDefaultPlannerPrompt = ({
  brandPresence,
  sourceDomain,
}: {
  brandPresence: PlannerBrandPresence;
  sourceDomain?: string | null;
}) => {
  if (brandPresence === "non_branded") {
    return DEFAULT_NON_BRANDED_PROMPT;
  }

  return sourceDomain ? `Create a social post concept for ${sourceDomain}.` : DEFAULT_PROMPT;
};

export const EMPTY_BRANDKIT = { logo: null, fonts: [] };
